import styles from '../css/globalPage.module.scss';
import { useTranslation } from 'react-i18next';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageContent}>
        <h1>{t('homePage.subject')}</h1>
      </div>
    </div>
  );
};

export default HomePage;
